import getSubdomain from 'utils/getSubdomain';
import saintGobain from './saint-gobain.svg';

const logos = {
  'saint-gobain': saintGobain,
};

export default logos[getSubdomain()] || '/ommnio.svg';
